<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode, animated: false, fadeIn: true }">
    <CCard :style="tankCardStyle(440, 500)" border-color="dark">
      <!-- 급유차는 입출고를 화면에서 조작하지 않는다 (show-inout=false) -->
      <CCardHeader>
        <TankCardHeader :tank="tank"
                        :signal-color="signalColor"
                        :status-variant="statusVariant"
                        :status-msg="statusMsg"
                        :status-blink="sts!=='N' && sts!=='F'"
                        :inout="inout"
                        :show-inout="false">
          <template #units>
            <TankUnitBadges :vol-unit="volUnit" :len-unit="lenUnit" :tmp-unit="tmpUnit"
                            @toggle-vol="toggleVolUnit" @toggle-len="toggleLenUnit" @toggle-tmp="toggleTmpUnit"/>
          </template>
          <template #identity>
            <CBadge :color="signalVariant(signalColor)"> {{tank.tid}} </CBadge>
            <CBadge :color="signalVariant(signalColor)" class="ml-1 mr-1" style="min-width:100px"> {{tank.name}} </CBadge>
          </template>
          <template #append>
            <small class="float-right"> {{ toShortTime(tankSts.ioAt) }} </small>
          </template>
        </TankCardHeader>
      </CCardHeader>

      <CCardBody>


      <CRow v-if="inout.sts!=='N'" class="mb-2">
        <CCol class="p-0 ml-1 text-center">
          <CBadge color="danger" class="mr-2">
            <strong>{{ trans(diffOvm, 'v', volUnit) }}</strong> <CBadge color="secondary">{{ unitSign(volUnit) }}</CBadge>
          </CBadge>

          <CBadge size="sm" color="primary"  class="mr-2">
            {{ inout.eqnm }} <strong :class="{blink: true}"> [{{ inout.eqid }}] </strong>
          </CBadge>

          <CBadge size="sm" color="info" v-show="inout.isDone">
            {{ MdcdMap[inout.mdcd] }} <strong :class="{blink: true}">{{ inout.ano }} </strong>
          </CBadge>

        </CCol>
      </CRow>



      <CRow>
        <CCol col="7" ref="container" class="p-0 position-relative">
          <!-- 발생한 경보 배지. 탱크 오른쪽 가운데(컨테이너 오른쪽 끝)에서 세로로 쌓아 표시한다 -->
          <WidgetEvents :events="events" :key="eventKey" vertical class="position-absolute evt-overlay"
                        :style="{ top: '50%', transform: 'translateY(-50%)', right: '0.25rem', zIndex: 11 }"/>
          <!-- 충족률. 탱크 그림 왼쪽 아래에 레이어로 표시 (상단 버튼 그룹에서 옮김) -->
          <div class="tvp-overlay" :class="{'font-lg': $store.state.largeFont}">{{ comma(pk.tvp, 0) }} %</div>
        </CCol>
        <CCol col="5">
          <TankDetailTable :pk="pk"
                            :tank="tank"
                            :status="status"
                            :vol-unit="volUnit"
                            :len-unit="lenUnit"
                            :tmp-unit="tmpUnit"
                            table-width=""
                            @toggle-detail="toggleDetail"/>
        </CCol>
      </CRow>
      <TankTempTable v-show="detailTmShow" :pk="pk" :tmp-unit="tmpUnit" :sensor-count="1"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<style>
.tooltip .tooltip-inner {
  text-align: left;
  max-width: 350px !important;
  width: 250px !important;
}

@keyframes blink-effect {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink-effect 1s step-end infinite;

  /*
  animation-name: blink-effect;
  animation-duration: 1s;
  animation-iteration-count:infinite;
  animation-timing-function:step-end;
  */
}


</style>

<script>
//------------------------------------------------------------------------
// import '../../common/HelperMixin';
import WidgetEvents from '../widget/WidgetEvents'
import TankCardHeader from './TankCardHeader'
import TankDetailTable from './TankDetailTable'
import TankUnitBadges from './TankUnitBadges'
import TankTempTable from './TankTempTable'
import * as THREE from 'three';
// import {CSG} from 'three-csg-ts';
import {PacketSchema} from "@/common/schema";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import {createTextSprite} from '@/common/three-label';
// import moment from 'moment';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {IoStsMap, IoStsVariant, MdcdMap} from '@/common/constants';

import {
  getHexColor,
  getR,
  clone,
  comma,
  trans,
  apiCall,
  unitSign,
  random,
  ltrToUnit
} from "@/common/utils";
import {gsap} from "gsap";


const _normalBadge = {'1':'dark', '2':'dark', '3':'dark', '4':'dark', '5':'dark', '6':'dark', '7':'dark', '8':'dark', '9':'dark'};

export default {
  name: "TankLorry",
  components: {
    WidgetEvents,
    TankCardHeader,
    TankDetailTable,
    TankUnitBadges,
    TankTempTable
  },
  props: {
    width: {type: Number, default: 300},
    height: {type: Number, default: 200},
    tank: { type: Object, default: null },
    bgColor: { type: String, default: '#FFFFFF'},
    tlgPacket : { type: Object, default: null },
    initPacket : { type: Object, default: null }
  },
// °C, °F , ㎜, in, gal ====> C,F,mm,in,gal
  data () {
    return {
      MdcdMap,
      tankSts: { io: '', ioAt: null },
      windowHeight: 0,
      windowWidth: 0,
      maxW: 5,
      maxH: 4,
      maxD: 14,
      baseY: 6,
      baseZ: -5,
      detailTmShow: false,
      eventKey: 0,
      statusMsg: 'wait.',
      statusVariant: 'dark',
      tid: '',
      inout: { sts: 'N' },
      sts: '',
      events: {data: [], dt: null},
      // eventTip: {},
      // eventLogs: [],
      trans: trans,
      unitSign: unitSign,
      volUnit: 'l', // <--> g
      lenUnit: 'mm', // <--> i
      tmpUnit: 'c', // <---> f
      comma: comma,
      // 1-넘침,2-부족,3-화재,4-수분,5-누유,6-넘침2,7-부족2,8-센서오류,9-패킷오류
      eventColor: {
        '1':'warning',
        '2':'warning',
        '3':'danger',
        '4':'info',
        '5':'danger',
        '6':'danger',
        '7':'danger',
        '8':'info',
        '9':'warning'
      },
      badgeColor: clone(_normalBadge),
      status: 'off', // norm, warn, info, off
      signalColor: 'dark',
      pk: clone(PacketSchema),
      w: 400,
      h: 250,
      cube: null,
      renderer: null,
      scene: null,
      camera: null,
      isPacketFirst: true,
      isCamMoved: false,
      controls: null,
      oilColors: this.$store.state.codeMaps['OIL_COLOR'],
      nozSizeMap: this.$store.state.codeMaps['NOZ_SIZE'],
      shapeMap: this.$store.state.codeMaps['TANK_SHAPE'],
      eventCodeMap: this.$store.state.codeMaps['EVENT'],
      machine: null,
      container: null,
      tankColor: null,
      colors: {
        pipe: '#F0F0F0',
        water: '#0000F0',
        sensor: {
          off: '#606050',
          on: '#16A2B8',
          warn: '#FFC008',
          info: '#047BFF',
          danger: '#DC3545',
          error: '#FF0000',
          unknown: '#FF00FF'
        },
        tm: {
          off: '#001233',
          on: '#FF00FF',
          danger: '#DC3545',
          error: '#FF0000',
          unknown: '#FF00FF',
        }, // 온도계 온도

        text: {
          oil: { norm:'success', warn:'danger', info: 'info' },
          wtr: { norm:'secondary', warn:'primary', info: 'info' },
          in : 'warning',
          out: 'dark',
        }
      },

      tankObj: null,

      geo: {
        tank: null,
        pipe: null,
        sensor: null,
        lvo: null,
        lvw: null,
        oil: null,
        wtr: null,
        tm : null,
        roof: null,
        roofDeco: null,
        bottom: null
      },

      mat: {
        tank: null,
        pipe: null,
        sensor: null,
        lvo: null,
        lvw: null,
        oil: null,
        wtr: null,
        roof: null,
        roofDeco: null,
        bottom: null
      },

      mesh: {
        tank: null,
        pipe: null,
        sensor: null,
        oil: null,
        wtr: null,
        lvo: null,    // render_volume_2 에서만 사용함 (유위, 박스지오메트리)
        lvw: null,    // render_volume_2 에서만 사용함 (수위, 박스지오메트리)
        oilVol: null, // render_volume_2 에서만 사용함 (최종유량)
        wtrVol: null, // render_volume_2 에서만 사용함 (최종수분)
        roof: null,
        roofDeco: null,
        bottom: null
      },

      tankOpenAngle: getR(45),
      tankCloseAngle: getR(280),
      tmMater: {}, // 온도계 Mater
      tmMesh: {}, // 온도계 메쉬
      camPos: {x:0, y:0, z:0},
      roofH: 0,
      bottomH: 0,
      senH: 11,
      tankH: 9,
      tankR: 9,
      oilColor: 0,
      oilH: 0.0,
      wtrH: 0.0,
      nozSize: 0,
      oilVol: 0,
      wtrVol: 0,
      diffOvm: 0, // inout differences
      targetVol: 0, // inout differences
      inputTargetVol: null,
      volPercent: 0,
    }
  },

  created(){
    console.warn("--- TankLorry --- created---------------------");
  },

  async mounted() {
    console.warn(`--- TankLorry --- mounted---20240705--------: ${this.tank.tid} ----------`);
    try {
        console.log(`---20240705 TankLorry mounted for TID: ${this.tank.tid} ---`);
        this.w = this.width;
        this.h = this.height;

        this.isPacketFirst = true;
        this.isCamMoved = false;

        if (this.tank) {
            await this.getStatus();

            this.init(this.tank.tankShape);
            console.log(`20240705 Tank shape initialized: ${this.tank.tankShape}`);

            this.initCamera();
            this.loadObjects();
            this.initRenderer();
            this.initVolume();
        }
    } catch (err) {
        console.error(`20240705 Error in mounted for TID: ${this.tank.tid}`, err);
    }
  },

  methods: {

    initVolume(){

      console.warn( `------------------initVolume()------------`);

      // this.geo.oil.dispose();
      // this.mesh.oil.geometry.dispose();

      // constructor( width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1 ) {
      const oilGeo = new THREE.BoxGeometry( this.maxW, this.maxH, this.maxD, );
      const oilMat = new THREE.MeshLambertMaterial({color: this.oilColor, side: THREE.DoubleSide, opacity: 0.1, transparent: true} );
      const oilMesh = new THREE.Mesh( oilGeo,  oilMat );

      this.geo.oil = oilGeo;
      this.mat.oil = oilMat;
      this.mesh.oil = oilMesh;

      oilMesh.position.set( 0, this.baseY, this.baseZ );
      oilMesh.updateMatrix();

      this.scene.add( this.mesh.oil );
      this.render();
    },

    /**
     * renderStock - 재고표시
     * @param tp
     */
    renderVolume(tp) {
      try{
        let oilH = (this.maxH * Number(tp.tvp)) / 100; // percent ex) (4 * 80.63) / 100
        let wtrH = 0;
        let oilY = 0;

        console.log( `TankLorry --- renderVolume--- [${tp.tid}]----> tankH=${this.tankH}, tankR=${this.tankR}, oilH=${oilH}, wtrH=${wtrH}, senH=${this.senH}`);

        this.geo.oil.dispose();
        // this.mesh.oil.dispose();
        // this.mat.oil.dispose();
        this.scene.remove( this.mesh.oil );

        const oilGeo = new THREE.BoxGeometry( this.maxW, oilH, this.maxD );
        this.mat.oil.opacity = 0.5;
        const oilMesh = new THREE.Mesh( oilGeo,  this.mat.oil );
        oilY = (this.maxH * -0.5) + (oilH * 0.5) + this.baseY;

        oilMesh.updateMatrix();

        this.geo.oil = oilGeo;
        this.mesh.oil = oilMesh;
        this.mesh.oil.position.set( 0, oilY, this.baseZ );

        console.warn( "TankLorry --- renderVolume --- maxH, tvp, oilH, oilY --->", this.maxH, tp.tvp, oilH, oilY );
        this.mat.oil.depthTest = false;
        this.mesh.oil.updateMatrix();

        this.scene.add( this.mesh.oil );
        // this.scene.add( this.mesh.tank );
        // this.render();
      }catch(err){
        console.error(err);
      }


    },


    /**
     * 온도계 Draw
     * @param sensorH 센서높이
     * @param tmSize 센서사이즈
     * @param tuneY 높이조절값
     */
    draw_thermometers(high, tmSize=0.5, tuneY=0 ){
      this.geo.tm    = new THREE.CylinderGeometry(this.nozSize, this.nozSize, tmSize, 36, 1);

      this.machine.temps.map(t=>{
        let tmKey = `tm${t.idx}`;
        let tlH = t.location * 0.001
        let tmH = -high * 0.5 + (tlH) + tuneY;

        this.tmMater[tmKey] = new THREE.MeshPhongMaterial({color: getHexColor(this.colors.tm.off), opacity: 1, transparent: false} );

        console.log( `render_volume_1_3()---[${this.tank.tid}]---draw_thermometers() --- tmKey = ${tmKey}, tmH = ${tmH}`);

        this.tmMesh[ tmKey ] = new THREE.Mesh( this.geo.tm,  this.tmMater[tmKey] );
        this.tmMesh[tmKey].position.set(0, tmH, 0);
        this.scene.add(this.tmMesh[tmKey]);
        // console.log( this.tank.tid, 'scene added tmKey--->', tmKey );
      });
    },


    init(){
      // 1: Exclusive, 2: 실린더(옆으로누운), 3:Cone roof, 4, Tank lorry, 5, pipeline, 6,drum
      const tank = this.tank;
      // console.log(`--- init Tank3D - TID : [${tank.tid}] ${this.shapeMap[tank.tankShape]}`)
      // console.log( '######################----------',tank.tid, tank.tankShape,'------ ########################' );
      if(tank.machine===null){
        console.error(`--- init Tank3D - TID : [${tank.tid}] Machine Not found`);
        return;
      }

      this.tid = tank.tid;
      this.machine = tank.machine;

      this.senH = this.machine.sensorLen / 1000;
      this.tankH = tank.tankHeight / 1000;
      this.tankR = tank.tankWidth / 2 / 1000;

      let nozSize = this.nozSizeMap[ tank.nozSize ];
      this.nozSize = Number(nozSize.replace(/[^0-9]/g, "")) / 1000;
      this.tankColor = getHexColor( tank.color );
      this.oilColor = getHexColor( this.oilColors[tank.oilCode] )
      // console.log( 'tank-color =', tank.color, ', oil-color =', this.oilColors[tank.oilCode] );

      /*console.log( tank.tid,'senH    --->', this.senH )
      console.log( tank.tid,'tankH   --->', this.tankH )
      console.log( tank.tid,'tankR   --->', this.tankR )
      console.log( tank.tid,'nozSize --->', this.nozSize )*/


      this.container = this.$refs['container'];
      this.scene = new THREE.Scene();

      this.camera = new THREE.PerspectiveCamera(
        55, // 45가 눈이보는 시야각과 유사
        this.w / this.h,
        0.4,
        2000); // 이설정 바꾸지 말것

      this.camPos.x = 30;
      this.camPos.y = 40;
      this.camPos.z = 40;

      let cp = this.camPos;
      this.camera.position.set( cp.x , cp.y, cp.z );

      // this.camera.position.set( 0, 0, this.tankR+16 ); // 정면
      this.camera.lookAt( -4, 1, -2 );


      const light = new THREE.DirectionalLight( 0xFFFFFF, 1 );
      light.position.set(10,24,-5);
      this.scene.add( light );
      // this.scene.add( new THREE.AmbientLight(0x000000) );
      this.scene.background = new THREE.Color( getHexColor(this.bgColor) );//

    },

    loadObjects() {
      console.log(`20240705 Loading objects for TID: ${this.tank.tid}`);
      const loader = new GLTFLoader();
      loader.load('gltf/tanklorry.glb', (gltf) => {
          const tankObj = gltf.scene;
          tankObj.scale.set(0.03, 0.03, 0.03);
          tankObj.position.set(0, 0, 0);
          console.log('20240705 tankObj', tankObj );

          tankObj.traverse((child) => {
              if (child.isMesh) {
                  child.material.color.set(0xf0f000);
                  child.material.transparent = true;
                  child.material.opacity = 0.3;

                  tankObj.updateMatrix();
                  this.mesh.tank = tankObj;
                  this.scene.add(this.mesh.tank);

                  this.setTextTest(this.tank.name);
              }
          });
          console.log(`20240705 Objects loaded for TID: ${this.tank.tid}`);
      }, undefined, (error) => {
          console.error('An error happened while loading the GLTF model:', error);
      });
    },

    initRenderer() {
      console.log(`20240705 Initializing renderer for TID: ${this.tank.tid}`);
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(this.w, this.h);
      this.renderer.sortObjects = false;
      this.container.appendChild(this.renderer.domElement);

      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.renderer.setAnimationLoop(this.animate);

      console.log(`20240705 Renderer initialized for TID: ${this.tank.tid}`);
    },

    animate: function() {
      // this.mesh.rotation.x += 0.01;
      // this.mesh.rotation.y += 0.02;
      this.render();

    },

    /**
     * 초기카메라 이동
     */
    initCamera() {

      // let tuneY = (shape==='2')? 2:0;
      const camera = this.camera
      gsap.to(camera.position, {
        duration: 1,
        repeat: 0,
        x: 8,
        y: 15,
        z: -20,
        onUpdate: () => {
          camera.lookAt(0, 0, 0);
        },
        onComplete: () => {}
      });

    },

    /**
     * 패킷 수신시 카메라 이동
     */
    moveCameraAction() {
      const camera = this.camera
      gsap.to(camera.position, {
        duration: 2,
        repeat: 0,
        x: 6,
        y: 9,
        z: -16,
        onUpdate: () => {
          camera.lookAt(-4, 1, -2);
        },
        onComplete: () => {}
      });

    },

    changeObjectColor: function (obj, color ){
      if(!obj) return;
      let colorHex = getHexColor(color)
      obj.color.set( colorHex );
      this.render();

    },

    /**
     * 센서 시그널 표시
     * @param type
     */
    sensorBlink: function(status='on'){
      this.changeObjectColor( this.mat.sensor,
        this.colors.sensor[status]? this.colors.sensor[status]:this.colors.sensor['unknown']
      );
      setTimeout(()=>{
        this.changeObjectColor( this.mat.sensor, this.colors.sensor.off );
      }, 500)
    },

    /**
     * 온도센서 시그널 표시
     * @param tmKey
     * @param type
     */
    tempBlink: function(tmKey, status='on'){
      // console.log( 'tmBlink()------', tmKey);
      this.changeObjectColor( this.tmMater[tmKey], this.colors.tm[status]? this.colors.tm[status]:this.colors.tm['unknown']);
      /*
      setTimeout(()=>{
        this.changeObjectColor( this.tmMater[tmKey], this.colors.tm.off );
      }, 800)
      */
    },


    /**
     * 입력 텍스트 드로우
     * @param title
     */
    setTextTest(title='') {
      const size = 0.6;

      // 스프라이트는 가운데 정렬에 항상 카메라를 향하므로,
      // 종전의 가로 중앙 이동(xMid)과 180도 회전이 필요없다.
      const label = createTextSprite( title ? title : 'ATG Sensor', {color: 0x0088AA, size} );
      label.position.set( 0, this.senH/2 + 2.1 + size/2, -12 );

      this.scene.add( label );
    },

    render(){
      // console.log(`Camera position: x=${this.camera.position.x}, y=${this.camera.position.y}, z=${this.camera.position.z}`);
      // console.log(`Camera lookAt: x=${this.controls.target.x}, y=${this.controls.target.y}, z=${this.controls.target.z}`);

       if(this.renderer) this.renderer.render( this.scene, this.camera );
    },

    destroyObjects(){
      // init() 이 끝나기 전에 화면을 벗어나면 renderer 가 없다
      if(!this.renderer) return;

      // 먼저 렌더 루프를 세운다. 정리 중에 프레임이 한 번 더 돌면
      // 방금 반납한 지오메트리를 three 가 다시 올린다.
      this.renderer.setAnimationLoop(null);

      // GLTF 로 불러온 탱크로리 모델은 this.geo/this.mat 에 없어 아래 정리 루프에 걸리지 않는다.
      // 모델 안의 지오메트리·재질·텍스처를 직접 반납한다.
      if(this.mesh.tank){
        this.mesh.tank.traverse((child)=>{
          if(!child.isMesh) return;
          child.geometry?.dispose();
          const materials = Array.isArray(child.material)? child.material : [child.material];
          materials.forEach(m=>{
            if(!m) return;
            Object.values(m).forEach(v=>{ if(v && v.isTexture) v.dispose(); });
            m.dispose();
          });
        });
      }

      // Mesh 제거
      Object.keys( this.mesh ).map(k=>{
        if(this.mesh[k]) this.scene.remove( this.mesh[k] );
        // this.mesh[k].dispose();
      });

      // 온도계 Mesh 제거
      Object.keys( this.tmMesh ).map(k=>{
        if(this.tmMesh[k]) this.scene.remove( this.tmMesh[k] );
        // this.mesh[k].dispose();
      });

      // Geometry 제거
      Object.keys( this.geo ).map(k=>{
        if(this.geo[k]) this.geo[k].dispose();
      });

      // Mater 제거
      Object.keys( this.mat ).map(k=>{
        if(this.mat[k]) this.mat[k].dispose();
      });

      // 온도계 Mater 제거
      Object.keys( this.tmMater ).map(k=>{
        if(this.tmMater[k]) this.tmMater[k].dispose();
      });

      // OrbitControls 가 캔버스에 건 pointer/wheel/contextmenu 리스너를 뗀다
      if(this.controls){
        this.controls.dispose();
        this.controls = null;
      }

      // 캔버스를 컨테이너에서 떼고 WebGL 컨텍스트를 반납한다.
      // renderer.dispose() 는 컨텍스트를 놓지 않는다. 반납은 forceContextLoss() 뿐인데
      // 주석 처리돼 있었고, 그보다 앞서 domElement 를 null 로 지워 캔버스를 뗄 수도 없었다.
      const canvasEl = this.renderer.domElement;
      if(canvasEl && canvasEl.parentNode) canvasEl.parentNode.removeChild(canvasEl);

      this.renderer.forceContextLoss();
      this.renderer.dispose();
      this.renderer = null;
    },

    async getStatus(){
      const rs = await apiCall('get', `/api/tank/status/${this.tank.tid}`);
      if(rs.code===200){
        this.tankSts = rs.result;
        this.sts = rs.result.io;
        this.statusMsg = IoStsMap[this.sts];

        console.log( 'tank status result -----> tid=',this.tid,'--->', rs.result  );
      }
      // await this.toastInfo(`입출고 상태 정보 업데이트`, 'info');
    },

    /**
     * call from parent component
     * @param data
     */
    setVolume(data){
      try {
        console.warn('TankLorry setVolume------------------- tid >>>>>>>>>>>>>>>>> ', data.tid);
        const tp = data.payload;

        console.warn('TankLorry setVolume------------------- packet >>>>>>>>>>>>>>>>>', data.payload);

        this.pk = tp;

        if (this.isPacketFirst) this.moveCameraAction( this.tank.tankShape );

        this.badgeColor = {'1':'dark', '2':'dark', '3':'dark', '4':'dark', '5':'dark', '6':'dark', '7':'dark', '8':'dark', '9':'dark'};
        this.status = 'on'

        if (tp.isEvt || tp.isErr) {
          this.status = 'warn';
          this.signalColor = tp.isErr ? 'danger' : 'warning';
          this.events.data = tp.events;
          this.events.dt = tp.dt;
        }else{
          this.events.data = [];
          this.events.dt = tp.dt;
          this.signalColor = 'info';
        }
        this.eventKey = random(1,10000);
        // console.log( 'TankLorry ----- events ------------> ', this.events );
        // console.log( 'TankLorry ----- signalColor ------------> ', this.signalColor );

        this.renderVolume(tp);

        this.setTankStatus( tp.sts );

        if( data.inout ) this.setInoutSts( data.inout );

        // 패킷 수신 표시(카드 테두리 색)를 2.5초 유지한 뒤 되돌린다
        setTimeout(() => {
          this.signalColor = "dark"
        }, 2500);
      }catch(err){
        console.log(err);
      }
    },

    setTankStatus(sts){
      this.tankSts = sts;
      const {io} = sts;
      console.log( 'setTankStatus --- inout ---> ',  sts);
      this.sts = io;
      this.statusMsg = IoStsMap[io];
      this.statusVariant = IoStsVariant[io];
    },

    setInoutSts(inout){
      console.log( 'setInoutSts ---------', inout );
      this.inout = inout;
      const {sts} = inout;

      if( sts==='N') return;

      switch(sts){
        case 'R':
          this.diffOvm = Math.abs(this.inout.outOvm); break;
        case 'D':
          this.diffOvm = this.inout.inOvm; break;
        default:
          break;
      }
    },

    async getInout(){
      const rs = await apiCall('get', `/api/inout/current/${this.tank.tid}`);
      if(rs.code===200){
        this.inout = rs.result;
        if( this.inout.sts!=='N') this.inputTargetVol = Math.round( ltrToUnit(this.inout.targetVol, this.volUnit) );
        console.log( 'inout result -----> tid=',this.tid,'--->', rs.result  );
        this.sts = rs.result.sts;
      }
      // await this.toastInfo(`입출고 상태 정보 업데이트`, 'info');
    },

    progressVariant(v){
      if(!v) return 'dark';

      if(v<10) return 'info';
      else if(v < 40) return 'primary';
      else if(v < 80) return 'success';
      else if(v < 95) return 'warning';
      else if(v >= 95) return 'danger';
      else return 'info';
    },


    /** 온도센서 표 펼치기/닫기 (평균온도 라벨 클릭) */
    toggleDetail(){
      this.detailTmShow = !this.detailTmShow;
    },

    // 상단 단위 배지 클릭: 해당 단위만 전환
    toggleVolUnit(){
      // L → kL → 드럼(D, 200L) → gal → L 순환
      const order = ['l', 'k', 'd', 'g'];
      this.volUnit = order[ (order.indexOf(this.volUnit) + 1) % order.length ];
      // 진행 중인 입출고 목표량 입력값도 새 단위로 다시 표시
      if( this.inout && this.inout.sts && this.inout.sts !== 'N' && this.inout.targetVol ){
        this.inputTargetVol = Math.round( ltrToUnit(this.inout.targetVol, this.volUnit) );
      }
    },
    toggleLenUnit(){ this.lenUnit = (this.lenUnit === 'mm') ? 'i' : 'mm'; },
    toggleTmpUnit(){ this.tmpUnit = (this.tmpUnit === 'c') ? 'f' : 'c'; },


  },
  watch:{
    tlgPacket(newTp, oldTp) {
      console.log( 'new packet ---', newTp)
      console.log( 'old packet ---', oldTp)

      this.renderVolume( newTp );

    },
    'tank': function() {
      console.log( 'change tank --->', this.tank );
      this.init();
    }

  },
  beforeDestroy(){
    // using "removeListener" here, but this should be whatever $socket provides
    // for removing listeners
    this.destroyObjects();


  },



}
</script>
